if(window.loadDebug) console.log("importing content-tag");

import {cT} from "./ct.js";
// const registerCt = (...args) => cT.register(...args);
export {cT};
